import { RouterProvider } from 'react-router';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';

import Locales from 'components/Locales';
import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';

// auth-provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { SessionExpireProvider } from './pages/sessionExpiredHandle/SessionExpireContext';
import useOnlineStatus from './hooks/useOnlineStatus';
import { useEffect, useRef } from 'react';
import { showNotification } from './services/notification';
import { useSnackbar } from 'notistack';
import { Button } from '@mui/material';
import GeoLocationGuard from './utils/route-guard/GeoLocationGuard';


export default function App() {

  const isOnline = useOnlineStatus();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const firstRender = useRef(true);
  const offlineSnackKey = useRef(null); // To track and close the offline alert

  useEffect(() => {
    // Skip the first run so it doesn't show "back online" on load
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    if (isOnline) {
      // Close the offline error if it was persistent
      if (offlineSnackKey.current) {
        closeSnackbar(offlineSnackKey.current);
      }

      enqueueSnackbar("You are back online!", {
        variant: 'success',
        autoHideDuration: 3000
      });
    } else {
      // Show persistent error until connection returns
      offlineSnackKey.current = enqueueSnackbar("You are offline. Check your connection.", {
        variant: 'error',
        persist: true,
        action: (key) => (
          <Button
            type="text"
            size="small"
            style={{ color: '#fff', fontWeight: 'bold', marginLeft: '10px' }}
            onClick={() => closeSnackbar(key)}
          >
            Close
          </Button>
        ),
      });

    }
  }, [isOnline, enqueueSnackbar, closeSnackbar]);

  return (
    <>
      <ThemeCustomization>
        <RTLLayout>
          <Locales>
            <ScrollTop>
              <AuthProvider>
                <GeoLocationGuard>
                  <SessionExpireProvider>
                    <Notistack>
                      <RouterProvider router={router} />
                      <Snackbar />
                    </Notistack>
                  </SessionExpireProvider>
                </GeoLocationGuard>
              </AuthProvider>
            </ScrollTop>
          </Locales>
        </RTLLayout>
      </ThemeCustomization>
    </>
  );
}
